import type { OperationsSnapshot } from '../../types/domain';

export const seedOperations = (businessId: string): OperationsSnapshot => ({
  businessId,
  suppliers: businessId === 'biz_casa_norte' ? [
    { id: 'sup_cafe_demo', businessId, name: 'Distribuidora Sierra', company: 'Distribuidora Sierra del Norte', contact: 'Laura Méndez', phone: '899 300 1040', whatsapp: '528993001040', email: 'ventas@sierra.demo', address: 'Parque Industrial 220, Reynosa', taxId: '', notes: 'Entrega martes y viernes.', status: 'active', balanceCents: 0, createdAt: '2026-07-01T14:00:00.000Z', updatedAt: '2026-07-01T14:00:00.000Z' },
    { id: 'sup_empaque_demo', businessId, name: 'Empaques Frontera', company: 'Empaques Frontera', contact: 'Óscar Villarreal', phone: '899 300 2050', whatsapp: '528993002050', email: 'pedidos@empaques.demo', address: 'Av. Industrial 88, Reynosa', taxId: '', notes: 'Pedido mínimo de $1,500.', status: 'active', balanceCents: 0, createdAt: '2026-07-02T14:00:00.000Z', updatedAt: '2026-07-02T14:00:00.000Z' },
  ] : [],
  purchases: [],
  expenses: [],
  goodsReceipts: [],
});
